import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useCreateSectionNode from 'api/locationsCategories/useCreateSectionNode';
import { MuiRTL } from 'lib/MuiRTL';
import React, { useState } from 'react';

const CreateSectionNodeModal = props => {
  const { guid } = props;

  const [createLoading, createSectionNode] = useCreateSectionNode();

  const [itemName, setItemName] = useState('');

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.closeHandler();
        setItemName('');
      }}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>افزودن طبقه</DialogTitle>

      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            autoFocus
            label="عنوان طبقه"
            variant="standard"
            value={itemName}
            onChange={e => setItemName(e.target.value)}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={createLoading}
          disabled={!itemName}
          onClick={() => createSectionNode(guid, itemName, props.refreshData)}
        >
          تایید
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={createLoading}
          onClick={() => {
            props.closeHandler();
            setItemName('');
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateSectionNodeModal;
